export var LOCALE = /*#__PURE__*/function (LOCALE) {
  LOCALE["KO_KR"] = "ko_KR";
  LOCALE["EN_US"] = "en_US";
  LOCALE["JA_JP"] = "ja_JP";
  LOCALE["ZH_CN"] = "zh_CN";
  return LOCALE;
}({});